export default function (cache: any, root_name: string) {
  const rootQuery = cache.data.data.ROOT_QUERY;
  Object.keys(rootQuery).forEach((key) => {
    if (key.match(RegExp(`^${root_name}`))) {
      cache.evict({ id: "ROOT_QUERY", fieldName: key });
    }
  });
  cache.gc();
}
